/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Step_2Inputs */

const en_claims_step_2 = /** @type {(inputs: Claims_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete the claim form.`)
};

const fr_claims_step_2 = /** @type {(inputs: Claims_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplissez le formulaire de réclamation.`)
};

/**
* | output |
* | --- |
* | "Complete the claim form." |
*
* @param {Claims_Step_2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_step_2 = /** @type {((inputs?: Claims_Step_2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Step_2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_step_2(inputs)
	return fr_claims_step_2(inputs)
});